module.exports = __webpack_public_path__ + "static/img/item-2-1-big.c08bcf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/innovation/item-2-1-big.png
// module id = kZzV
// module chunks = 2